"use strict";

require("core-js/modules/es6.string.bold");

require("core-js/modules/es6.string.small");

require("core-js/modules/es6.object.define-property");

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_1 = __importDefault(require("@emotion/styled"));

var theme_1 = require("../../styles/theme");

var Body = styled_1["default"].p(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  font-size: ", ";\n  font-style: ", ";\n  font-weight: ", ";\n  letter-spacing: ", ";\n  line-height: ", ";\n  margin: 0 0 ", ";\n  opacity: ", ";\n  ", "\n  text-align: ", ";\n"], ["\n  color: ", ";\n  font-size: ", ";\n  font-style: ", ";\n  font-weight: ", ";\n  letter-spacing: ", ";\n  line-height: ", ";\n  margin: 0 0 ", ";\n  opacity: ", ";\n  ", "\n  text-align: ", ";\n"])), function (props) {
  return props.dark ? theme_1.theme.primaryDarkColor : props.secondary ? theme_1.theme.secondaryColor : theme_1.theme.primaryColor;
}, function (props) {
  if (props.xxsmall) {
    return theme_1.theme.fontSizes.xxsmall;
  } else if (props.xsmall) {
    return theme_1.theme.fontSizes.xsmall;
  } else if (props.small) {
    return theme_1.theme.fontSizes.small;
  } else if (props.medium) {
    return theme_1.theme.fontSizes.medium;
  } else if (props.large) {
    return theme_1.theme.fontSizes.large;
  } else {
    return theme_1.theme.fontSizes.medium;
  }
}, function (props) {
  return props.italic ? 'italic' : 'inherit';
}, function (props) {
  return props.bold ? 900 : 500;
}, function (props) {
  return props.small ? '0.512px' : '0.262px';
}, function (props) {
  return props.small ? '1.5' : '1.6';
}, function (props) {
  return props.bottomMargin ? theme_1.theme.spacing.standard + 'px' : '0';
}, function (props) {
  return props.transparent ? 0.33 : 1;
}, function (props) {
  return typeof props.selected !== 'undefined' && "\n    color: " + (!props.selected && theme_1.theme.colors.Transparent.White67) + ";\n    &:hover {\n      color: " + (!props.selected && theme_1.theme.primaryDarkColor) + "\n    }\n  ";
}, function (props) {
  return props.center ? 'center' : 'inherit';
});
exports["default"] = Body;
var templateObject_1;